
import { generateId, formValue, formErrors } from "../../helpers/composition";
import Form from "../../helpers/form";

export default {
  name: "check-input",
  props: {
    name: String,
    form: Form,
    label: {
      type: String,
      default: (props) => props.form.labels[props.name],
    },
    list: Array,
    inline: {
      type: Boolean,
      default: () => false,
    },
    cast: {
      type: String,
      default: () => false,
    },
  },
  setup(props, context) {
    const id = generateId(props, context);
    const value = formValue(props);

    const update = (event) => {
      const list = props.form.model[props.name];
      let inputValue = event.target.value;
      if (props.cast) {
        if (props.cast === "integer") {
          inputValue = parseInt(inputValue);
        } else if (props.cast === "float") {
          inputValue = parseFloat(inputValue);
        } else if (props.cast === "boolean") {
          inputValue = inputValue === "true";
        }
      }
      if (event.target.checked) {
        list.push(inputValue);
      } else {
        list.splice(list.indexOf(inputValue), 1);
      }
      props.form.update({ [props.name]: list });
      props.form.touch(props.name);
    };

    return {
      id,
      value,
      update,
      ...formErrors(props),
    };
  },
};
